import { render, staticRenderFns } from "./PremioTable.vue?vue&type=template&id=a9ef57d6&lang=pug&"
import script from "./PremioTable.vue?vue&type=script&lang=js&"
export * from "./PremioTable.vue?vue&type=script&lang=js&"
import style0 from "./PremioTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports